export default __webpack_public_path__ + "static/media/checkbox_error_mobile.9c5d6b04.svg";